import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6b41bfbc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b41bfbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b41bfbc')) {
      api.createRecord('6b41bfbc', component.options)
    } else {
      api.reload('6b41bfbc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6b41bfbc&scoped=true&", function () {
      api.rerender('6b41bfbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bRE5Hmmg3mpb/JS/comp/SearchFilterTokens.vue"
export default component.exports